import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store";
import { routes } from "constants/routes";

const DefaultRedirect: React.FC = () => {
  const { userToken } = useSelector((state: RootState) => state.authState);
  return <Navigate to={userToken ? routes.HOME : routes.SIGNIN} replace />;
};

export default DefaultRedirect;
